/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenTabletVIcon24Regular = forwardRef('TechScreenTabletVIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 17.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2.25A3.75 3.75 0 0 0 3.25 6v12A3.75 3.75 0 0 0 7 21.75h10A3.75 3.75 0 0 0 20.75 18V6A3.75 3.75 0 0 0 17 2.25H7ZM4.75 6A2.25 2.25 0 0 1 7 3.75h10A2.25 2.25 0 0 1 19.25 6v12A2.25 2.25 0 0 1 17 20.25H7A2.25 2.25 0 0 1 4.75 18V6Z" })));
});
